export function getPartnerSiteUrl(partner = {}) {
  const host = String(partner.custom_domain || "").trim().toLowerCase();
  if (/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/.test(host)) {
    return `https://${host}`;
  }
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(partner.slug || "")
    ? `https://${partner.slug}.procertcompliance.com`
    : "https://procertcompliance.com";
}

export function safeImageUrl(value, fallback = "") {
  try {
    const url = new URL(value, "https://placeholder.invalid");
    if (!["http:", "https:"].includes(url.protocol)) return fallback;
    if (/chatgpt\.com$/.test(url.hostname)) return fallback;
    if (
      !/\.(png|jpe?g|webp|gif|svg|avif|ico)$/i.test(url.pathname) &&
      !url.pathname.includes("/storage/v1/")
    ) return fallback;
    return value;
  } catch {
    return fallback;
  }
}

export function getPartnerMetadata(partner) {
  const settings = partner.branding_settings || {};
  const appName = settings.store_name || partner.name || partner.slug;
  const siteUrl = getPartnerSiteUrl(partner);
  const favicon = safeImageUrl(settings.logo_url, `${siteUrl}/favicon.svg`);
  return {
    appName,
    email: settings.support_email || "",
    phone: settings.contact_phone || settings.support_whatsapp || "",
    siteUrl,
    favicon,
    title: settings.meta_title ||
      `${appName} - ISO Certification Training Platform`,
    description: settings.meta_description || settings.tagline ||
      settings.welcome_message ||
      `Professional ISO certification training by ${appName}.`,
    ogImage: safeImageUrl(settings.meta_image, favicon),
  };
}
